import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Pagination } from 'react-bootstrap';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import React from 'react';

export function Funcionarios() {
  const [isLoading, setIsLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [nivelAcesso, setNivelAcesso] = useState();

  const [employees, setEmployees] = useState([]); // Estado para armazenar os funcionários

  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(20);
  const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

  const [searchQuery, setSearchQuery] = useState('');
  const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

  // Calcula o índice do primeiro e do último funcionário na página atual
  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

  const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

  const filteredEmployees = employees.filter((employee: any) => {

    const cpfClean = employee.cpf.replace(/[\.-]/g, ''); // Remove '.' e '-'

    return (
      employee.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
      cpfClean.includes(searchQuery) ||
      employee.id.toString().includes(searchQuery)
    );
  });

  useEffect(() => {
    api.get('nivel-acesso').then((response: any) => {
      setNivelAcesso(response.data.nivel)
    })
  }, [])

  useEffect(() => {
    const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
    const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
    const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

    setCurrentFilteredEmployees(newCurrentFilteredEmployees);
  }, [currentPage, employeesPerPage, filteredEmployees]);

  // Function to load companies
  const loadCompanies = async () => {
    try {
      const response = await api.get('empresas');
      setCompanies(response.data.message ? [] : response.data);
      setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadEmployees = async (companyId: any) => {
    if (companyId) {
      try {
        const response = await api.post('funcionarios', { id_empresa: companyId });
        setEmployees(response.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    }
  };

  const handleEmployeesPerPageChange = (value: any) => {
    setEmployeesPerPage(Number(value));
    setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
  };



  // Load companies initially
  useEffect(() => {
    loadCompanies();
  }, []);

  useEffect(() => {
    loadEmployees(selectedCompany);
  }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

  const handleSelectCompany = (id: any) => {
    setSelectedCompany(id);
  };

  const handleStatusChange = async (employeeId: any, currentStatus: any) => {
    const newStatus = currentStatus === true ? false : true;

    try {
      await api.post('status-funcionarios', { id_empresa: selectedCompany, id_funcionario: employeeId, status: newStatus });
      // Reload employees to reflect the change
      loadEmployees(selectedCompany);
    } catch (error) {
      console.error("Error updating employee status:", error);
    }
  };

  // Atualizar a consulta de pesquisa
  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
    setCurrentPage(1);
  };

  /*paginação*/
  const paginationItems = () => {
    let items = [];
    const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

    // Primeira página
    if (currentPage > 2) {
      items.push(
        <Pagination.Item
          key="first"
          onClick={() => setCurrentPage(1)}
        >
          1
        </Pagination.Item>
      );
    }

    // Reticências antes da página atual, se necessário
    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
    }

    // Página anterior à atual, se aplicável
    if (currentPage > 1) {
      items.push(
        <Pagination.Item
          key={currentPage - 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          {currentPage - 1}
        </Pagination.Item>
      );
    }

    // Página atual
    items.push(
      <Pagination.Item
        key={currentPage}
        active
      >
        {currentPage}
      </Pagination.Item>
    );

    // Página seguinte à atual, se aplicável
    if (currentPage < totalPaginas) {
      items.push(
        <Pagination.Item
          key={currentPage + 1}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          {currentPage + 1}
        </Pagination.Item>
      );
    }

    // Reticências depois da página atual, se necessário
    if (currentPage < totalPaginas - 2) {
      items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
    }

    // Última página
    if (currentPage < totalPaginas - 1) {
      items.push(
        <Pagination.Item
          key="last"
          onClick={() => setCurrentPage(totalPaginas)}
        >
          {totalPaginas}
        </Pagination.Item>
      );
    }

    return items;
  };


  return (
    <div>
      <Load isLoading={isLoading} />
      <Sidebar />
      <Header route='./' />
      <Main>
        <>
          {companies.length === 0 ? (

            <CardContent>
              <Text text="Você precisa registrar uma empresa para cadastrar funcionários." />
            </CardContent>

          ) : (
            <>
              <CardContent>
                <div className='d-flex align-items-center' style={{ width: '100%' }}>
                  <Text text="Empresa" />
                  <Select width="600px" id='empresas' onSelect={handleSelectCompany}>
                    {companies.map((company: any, index: any) => (
                      <Options key={company.id} value={company.id} name={company.nome} selected={index === 0} />
                    ))}
                  </Select>
                </div>
              </CardContent>
              <CardContent>
                <Row className='my-4'>
                  <Title text="Funcionários" />
                  <Col md={8}>
                    {nivelAcesso !== 4 && (
                      <Button className='newbutton' href={`funcionarios/cadastrar/${selectedCompany}`}><FillPlus /> Novo funcionário</Button>
                    )}
                  </Col>
                  <Col md={4}>
                    <Search placeHolder="Procure pelo Nome ou CPF" onChange={handleSearchChange} />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={10} className='my-2 d-flex align-items-end'>
                    <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>

                  </Col>
                  <Col sm={2} className='my-2 d-flex justify-content-end'>
                    <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                      {employeesPerPageOptions.map((option) => (
                        <Options
                          key={option}
                          value={option}
                          name={`${option} por página`}
                          selected={option === employeesPerPage}
                        />
                      ))}
                    </Select>

                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                      <div style={{ overflow: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                              <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>CÓD</th>
                              <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                              <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>CPF</th>
                              <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Função</th>
                              <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Status</th>
                              {nivelAcesso !== 4 && (
                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ações</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {currentFilteredEmployees.length > 0 ? (
                              currentFilteredEmployees.map((employee: any) => (
                                <React.Fragment key={employee.id}>
                                  <tr style={{ textAlign: 'center' }}>
                                    <td className={`${employee.status == true ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.id}</td>
                                    <td className={`${employee.status == true ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.nome.toUpperCase()}</td>
                                    <td className={`${employee.status == true ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.cpf}</td>
                                    <td className={`${employee.status == true ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.ateBaseFuncao ? employee.ateBaseFuncao.nome : 'Não definido'}</td>
                                    <td className={`${employee.status == true ? '' : 'text-danger'}`} style={{ padding: '15px', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.status == true ? 'ATIVO' : 'DEMITIDO'}</td>
                                    {nivelAcesso !== 4 && (
                                      <td style={{ padding: '15px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                        <Button variant='outline-main' href={`funcionarios/editar/${employee.id}`} style={{ fontSize: '13px' }}>Editar</Button>
                                        <Button
                                          variant={`${employee.status == true ? 'outline-danger' : 'outline-success'}`}
                                          onClick={() => handleStatusChange(employee.id, employee.status)}
                                          style={{ fontSize: '13px' }}>
                                          {employee.status == true ? 'Demitir' : 'Reativar'}
                                        </Button>
                                      </td>
                                    )}
                                  </tr>
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                  Não há dados para serem mostrados
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col className='d-flex justify-content-center mt-4'>
                    <div className="pagination">
                      <Pagination>
                        {paginationItems()}
                      </Pagination>
                    </div>
                  </Col>
                </Row>
              </CardContent>
            </>
          )}
        </>
      </Main>
    </div >
  );
}